import React from 'react';
import '../less/payments-page.less';
import FAQStorybook from '@abank/abank-faq';
import QuestionsAdminNew from '../../../../../auxiliary-components/shared/QuestionsAdminNew';
import hero_img from '../img/hero_img.png';
import Hero from '../../../../../auxiliary-components/shared/HeroBlock';
import {downloadA24, servicesPaymentsTariffsLink} from '../../../../../services/urls/urls';
import howToBlockItemsData from '../enums/how_to_block_items.json';
import how_to_block_img_1 from '../img/how_to_block_img_1.png';
import how_to_block_img_2 from '../img/how_to_block_img_2.png';
import how_to_block_img_3 from '../img/how_to_block_img_3.png';
import how_to_block_img_4 from '../img/how_to_block_img_4.png';
import { filterByEnvironment } from '../../../../../helpers/utils/environmentFilter';
import hero_data from '../enums/hero_data.json';
import canPayData from '../enums/can_pay_data.json';
import HowToBlockNew from '../../../../../auxiliary-components/shared/HowToBlockNew';
import FilesForDownloadNew from '../../../../../auxiliary-components/shared/FilesForDownloadNew';
import { Preloader } from 'MWComponents';
import { canUseDOM } from '../../../../../helpers/canUseDOM';
import TransferTableNew from '../../../../../auxiliary-components/shared/TransfersTableNew';
import Tabs from '../../../../../auxiliary-components/shared/Tabs';
import table_data from '../enums/table_data.json';
import table_a24_data from '../enums/table_a24_data.json';
import table_tso_data from '../enums/table_tso_data.json';
import requisites_banner_img from '../img/requisites_banner_img.png';
import { getSafeLinkProps } from '../../../../../helpers/utils/urlSecurity';
import DOMPurify from 'utils/sanitize';
import { URL_AI_REQUISITES_PAYMENT } from '../../../../HomeNew/variables';

const imagesMap = {
  how_to_block_img_1,
  how_to_block_img_2,
  how_to_block_img_3,
  how_to_block_img_4
};

export default function template() {
  const page = "payments-page-new";

  const isMobile = this.isViewportMobile();

  const makePayment = isMobile ? downloadA24 : "/services/payments/payment";

  const tabs = [{tab: 'cash-desk', title: 'PAYMENTS_NEW_TABS_TITLE_01'},
      {tab: 'app', title: 'PAYMENTS_NEW_TABS_TITLE_02'},
      {tab: 'tso', title: 'PAYMENTS_NEW_TABS_TITLE_03'}];
      
  const handlersMap = {
    makePayment: makePayment,
  };

  const heroData = {
    ...hero_data,
    link: {
      ...hero_data.link,
      href: handlersMap[hero_data.link.href],
    },
  };

  const howToBlockItems = howToBlockItemsData.map(item => ({
    ...item,
    img: imagesMap[item.img]
  }));

  const questionsWidget = this.widgetsHelper.getWidget.call(this, 'questions');

  return (
    <div className="payments-page-new">
      <Hero
        data={heroData}
        img={hero_img}
      />
      <div className={`content${this.state.faqTab ? ' hidden' : ''}`}>
        <div className="requisites-banner">
          <div className="container">
            <a className="requisites-banner__body" {...getSafeLinkProps(URL_AI_REQUISITES_PAYMENT)}>
              <div className="requisites-banner__left">
                <h2 className="requisites-banner__title" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(this.l10n('PAYMENTS_NEW_REQUISITES_BANNER_TITLE'))}}></h2>
                <div className="requisites-banner__text" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(this.l10n('PAYMENTS_NEW_REQUISITES_BANNER_TEXT'))}}></div>
                <span className="requisites-banner__btn">{this.l10n('PAYMENTS_NEW_REQUISITES_BANNER_BTN')}</span>
              </div>
              <img className="requisites-banner__image" src={requisites_banner_img} alt={this.l10n('PAYMENTS_NEW_REQUISITES_BANNER_TITLE')}  />
            </a>
          </div>
        </div>
        <div className="can-pay">
          <div className="container">
            <h2 className="can-pay__title">{this.l10n('PAYMENTS_NEW_CAN_PAY_TITLE')}</h2>
            <div className="can-pay__body">
              {canPayData.map((item, index) => (
                <div key={index} className="can-pay__item item-can-pay">
                  <div className="item-can-pay__title">{this.l10n(item.title)}</div>
                  <div className="item-can-pay__text">{this.l10n(item.text)}</div>
                </div>
              ))}
            </div>
            <p className="can-pay__text">{this.l10n('PAYMENTS_NEW_CAN_PAY_TEXT')}</p>
          </div>
        </div>
        <HowToBlockNew
          title={'PAYMENTS_NEW_HOW_TO_TITLE'}
          items={howToBlockItems}
        />
        <Tabs tabs={tabs} toggle={this.toggleTab} tab={this.state.tab} title={'PAYMENTS_NEW_TABS_TITLE'} subtitle={'PAYMENTS_NEW_TABS_SUBTITLE'}>
          <TransferTableNew 
            data={table_data}
            text={'PAYMENTS_NEW_CASH_DESK_TABLE_TEXT'}
            btnLink={servicesPaymentsTariffsLink}
            btnText={'PAYMENTS_NEW_TABLE_BTN'}
          />
          <TransferTableNew 
            data={table_a24_data}
            text={'PAYMENTS_NEW_APP_TABLE_TEXT'}
            btnLink={servicesPaymentsTariffsLink}
            btnText={'PAYMENTS_NEW_TABLE_BTN'}
          />
          <TransferTableNew 
            data={table_tso_data}
            text={'PAYMENTS_NEW_TSO_TABLE_TEXT'}
            btnLink={servicesPaymentsTariffsLink}
            btnText={'PAYMENTS_NEW_TABLE_BTN'}
          />
        </Tabs>
        {this.state.loader ? (canUseDOM ? <Preloader /> : null) : (
          <>
            <QuestionsAdminNew
              widget={questionsWidget}
              toggleFaqTab={this.toggleFaqTab}
              title={'PAYMENTS_NEW_QUESTIONS_TITLE'}
            />
            <FilesForDownloadNew
              widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}
            />
          </>
        )}
      </div>
      <div className={`content${!this.state.faqTab ? ' hidden' : ''}`}>
        <FAQStorybook
          widget={questionsWidget}
          title={this.l10n('PAYMENTS_NEW_FAQ_STORYBOOK_TITLE')}
          btnText={this.l10n('PAYMENTS_NEW_FAQ_STORYBOOK_BTN_TEXT')}
          onBtnClick={this.toggleFaqTab}
          filterByEnvironment={filterByEnvironment}
        />
      </div>
    </div>
  )
}
